export const selectDashboard = (state) =>
  state.privacyKitConsentManagement.dashboard;

export const selectDashboardProcessingPurpose = (state) =>
  state.privacyKitConsentManagement.dashboard.processingPurpose;
